export default __webpack_public_path__ + "static/media/2_0006.4bcfea64.webp";